// @ is an alias to /src
// import { firebase, auth, firestore, db } from '@/firebase.js'
import { firestore, db } from '@/firebase.js'
import _ from 'lodash'

const debug = false;
const name = 'store/modules/users.js';

const state = {
  users: [] // all users
}

const getters = {
  getUsers: (state) => {
    return state.users;
  }
}

const mutations = {
  /**
   * @protected setUser mutation
   * @param {*} user data
   */
  setUser(state, userData) {
    if (debug) console.log(name, 'mutation setUser() userData:', userData)
    // if (debug) console.log(name,'mutation setUser() user updated in users ************** state.users:',state.users)
    let findIndex = state.users.find((user) => {
      if (debug) console.log(name, 'mutation setUser() §§§ user:', user)
      return user.uid === userData.uid
    })
    if (findIndex >= 0 && !_.isEqual(state.users[findIndex], userData)) {
      if (debug) console.log(name, 'mutation setUser() user updated in users ************** userData:', userData)
      state.users[findIndex] = userData
    }
    // if (debug) console.log(name,'mutation setUser() user updated in users ************** state.users:',state.users)
  },

  /**
   * @protected setUsers mutation
   * @param {*} user data
   */
  setUsers(state, users) {
    if (debug) console.log(name, 'mutation setUsers() users:', users)
    // let newUser = null
    // if (user) newUser = getUserObjectFromUserAuth(user)
    if (!_.isEqual(state.user, users)) {
      if (debug) console.log(name, 'mutation setUsers() user updated')
      state.users = users
    }
  },
}

const actions = {

  /**
   * @protected getUser action
   * @returns Promise
   */
  // getUser ({ state, getters }, userId) {
  getUser(context, userId) {
    return new Promise((resolve, reject) => {
      if (debug) console.log(name, 'action getUser() userId:', userId);
      if (!userId) {
        reject('userId not set')
      }
      db.collection('users').doc(userId).get()
        .then((document) => {
          if (document.exists) {
            let userData = document.data();
            if (debug) console.log(name, 'action getUser() user updated in users ************** userData:', userData)
            // if (debug) console.log(name,'action getUser() user updated in users ************** state.users:',state.users)
            // if (debug) console.log(name,'action getUser() user updated in users ************** state.auth:',state.auth)
            // if (debug && state.auth) console.log(name,'action getUser() user updated in users ************** state.auth.user:',state.auth.user)
            // if (debug) console.log(name,'action getUser() user updated in users ************** state[users.users]:',state['users.users'])
            // if (debug) console.log(name,'action getUser() user updated in users ************** state[users/users]:',state['users/users'])
            // if (debug) console.log(name,'action getUser() user updated in users ************** getters[users/getUsers]:',getters['users/getUsers'])
            resolve(userData)
          }
          else {
            reject('User not found')
          }
        })
        .catch((error) => {
          if (debug) console.log(name, 'action getUser() error:', error)
          reject(error)
        })
    })
  },

  /**
   * @protected setUser action
   * @returns Promise
   */
  setUser ({ commit }, userData) {
    return new Promise((resolve, reject) => {
      if (debug) console.log(name, 'action setUser() userData:', userData);
      if (!userData || !userData.uid) {
        resolve()
      }
      let docRef = db.collection('users').doc(userData.uid)
      docRef.get().then((doc) => {
        if (!doc.exists) {
          userData.createDate = firestore.FieldValue.serverTimestamp();
          if (debug) console.log(name, 'action setUser() Create new user. userData:', userData);
        }
        return docRef.set(userData, { merge: true })
        .then((data) => {
          if (debug) console.log(name, 'action setUser() user updated in users. data:', data)
          commit('setUser', userData)
          resolve()
        })
      })
      .catch((error) => {
        if (debug) console.log(name, 'action setUser() error:', error)
        reject(error)
      })
    })
  }

}

export default {
  namespaced: true,

  state,
  getters,
  mutations,
  actions
}
